import React, { useState } from "react";
import { Modal, Form, InputGroup, Row, Col } from "react-bootstrap";
import { Avatar, IconButton } from "@mui/material";
import { Send } from "@mui/icons-material";
import "./styles.css";

const BuyerChatModal = ({ show, onHide, product, seller }) => {
  const [messages, setMessages] = useState([
    { sender: "seller", text: "Hi, this is available.", timestamp: "10:30 AM" },
    { sender: "buyer", text: "Great, I’m interested.", timestamp: "10:32 AM" },
  ]);
  const [newMessage, setNewMessage] = useState("");

  const handleSend = () => {
    if (!newMessage.trim()) return;
    setMessages([
      ...messages,
      { sender: "buyer", text: newMessage, timestamp: "Just now" },
    ]);
    setNewMessage("");
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      backdrop={false}
      keyboard={false}
      dialogClassName="buyer-chat-modal"
    >
      {/* Header */}
      <Modal.Header closeButton className="bg-light py-2 border-bottom">
        <Row className="w-100 align-items-center g-2">
          <Col xs="auto">
            <Avatar sx={{ bgcolor: "primary.main", width: 32, height: 32 }}>
              {seller?.name?.charAt(0) || "S"}
            </Avatar>
          </Col>
          <Col>
            <h6 className="mb-0" style={{ fontSize: "0.9rem" }}>
              {seller?.name || "Seller"}
            </h6>
            <small className="text-muted">{product?.name || "Product"}</small>
          </Col>
        </Row>
      </Modal.Header>

      {/* Messages */}
      <Modal.Body
        style={{
          height: "400px", // fixed height for consistency
          maxHeight: "70vh",
          overflowY: "auto",
          background: "#f9fafb",
          padding: "12px",
        }}
      >
        {messages.map((msg, idx) => (
          <div
            key={idx}
            className={`d-flex mb-2 ${
              msg.sender === "buyer"
                ? "justify-content-end"
                : "justify-content-start"
            }`}
          >
            <div
              className={`p-2 rounded-3 shadow-sm ${
                msg.sender === "buyer"
                  ? "bg-primary text-white"
                  : "bg-white text-dark"
              }`}
              style={{ maxWidth: "75%", fontSize: "0.85rem" }}
            >
              <div>{msg.text}</div>
              <small
                className={`d-block mt-1 ${
                  msg.sender === "buyer" ? "text-light" : "text-muted"
                }`}
                style={{ fontSize: "0.7rem" }}
              >
                {msg.timestamp}
              </small>
            </div>
          </div>
        ))}
      </Modal.Body>

      {/* Input */}
      <Modal.Footer className="border-0 p-2">
        <InputGroup>
          <Form.Control
            placeholder="Type a message..."
            className="rounded-pill"
            value={newMessage}
            onChange={(e) => setNewMessage(e.target.value)}
            style={{ fontSize: "0.85rem" }}
          />
          <IconButton color="primary" sx={{ ml: 1 }} onClick={handleSend}>
            <Send fontSize="small" />
          </IconButton>
        </InputGroup>
      </Modal.Footer>
    </Modal>
  );
};

export default BuyerChatModal;
